import { ChapterHeading } from "@/components/ChapterHeading";
import { ParallaxImage } from "@/components/ParallaxImage";
import { FadeUp } from "@/components/KineticText";
import { PROJECTS } from "@/data/profile";

const Meta = ({ p }) => (
  <FadeUp className="mt-6 grid grid-cols-12 gap-4">
    <div className="col-span-12 md:col-span-2 eyebrow">{p.year}</div>
    <div className="col-span-12 md:col-span-10">
      <h3 className="font-display uppercase text-3xl md:text-4xl leading-none">{p.name}</h3>
      <p className="eyebrow mt-2 normal-case tracking-normal text-xs">{p.type}</p>
      <p className="mt-4 text-sm text-muted leading-relaxed max-w-lg">{p.body}</p>
    </div>
  </FadeUp>
);

export const Projects = () => {
  const [current, ...rest] = PROJECTS;
  return (
    <section id="rigs" data-testid="rigs-section" className="border-t hairline px-6 md:px-12 py-24 md:py-40">
      <ChapterHeading num="07" label="Selected rigs" title={["Steel I have", "answered for"]} />

      <article data-testid={`project-${current.id}`} className="mt-16 md:mt-24 grid grid-cols-12 gap-6 md:gap-10 items-end">
        <div className="col-span-12 md:col-span-5">
          <ParallaxImage src={current.image} alt={current.name} className="aspect-[4/5] border hairline" strength={8} shade={false} />
        </div>
        <div className="col-span-12 md:col-span-6 md:col-start-7 pb-2">
          <span className="inline-flex items-center gap-3 eyebrow !text-[var(--accent)] border border-[var(--accent)] px-3 py-2">
            <span className="live-dot inline-block w-2 h-2 bg-[var(--accent)]" /> Current station
          </span>
          <Meta p={current} />
        </div>
      </article>

      <div className="mt-24 md:mt-32 grid grid-cols-12 gap-6 md:gap-10">
        {rest.map((p, i) => (
          <article key={p.id} data-testid={`project-${p.id}`} className={`col-span-12 ${i === 0 ? "md:col-span-12" : "md:col-span-6"}`}>
            <ParallaxImage src={p.image} alt={p.name} className={`${i === 0 ? "aspect-[21/9]" : "aspect-[16/10]"} border hairline`} strength={10} />
            <Meta p={p} />
          </article>
        ))}
      </div>
    </section>
  );
};
